/* eslint-disable consistent-return */
import React, { Component } from 'react';
import { Form } from 'react-form';
import {
    Input,
    Textarea,
    SchoolSearch,
    PhoneNumber,
    Select,
    Location,
    CheckBox,
} from '../../Form';
import {
    monthOptions,
    // supportedPlayerStudentFileTypes
    supportedPlayerStudentFileTypesAcceptsString,
    supportedPlayerStudentFileTypesForInfoButton,
} from '../../../utils/constants';
import { getPlayerGradYearOptions } from '../../../utils';
import { createReactFormValidator, integer, range, required } from '../../../utils/validation';
import { intlPhoneNumber } from '../../../utils/validation-libdep';
import { LinkAnchor } from '../../Links';
import Img from '../../Img';
import InfoButton from '../../InfoButton';
import TrackedClick from '../../Analytics/TrackedClick';
import { getClickAttrs } from '../../Analytics/gtag';

import styles from './studentContent.scss';

class StudentTabEditForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { handleSubmit, handleCancel, defaultValues, submitting } = this.props;

        const onKeyDown = (event) => {
            if (event.key === 'Enter' && event.target.type !== 'submit' && event.target.type !== 'button' && event.target.id !== 'description') {
                event.preventDefault();
            }
        };

        const relationshipOptions = [
            {
                id: 1,
                label: 'Player',
                value: 'player',
            },
            {
                id: 2,
                label: 'Parent',
                value: 'parent',
            },
            {
                id: 3,
                label: 'Coach',
                value: 'coach',
            },
            {
                id: 4,
                label: 'Recruiting Service',
                value: 'recruitingService',
            },
        ];

        const gradYearOptions = getPlayerGradYearOptions(true);

        return (
            <Form onSubmit={values => handleSubmit({ values })} defaultValues={defaultValues}>
                {({ submitForm, values, setValue, touched, getWarning, getError }) => {
                    const error = getError('highSchoolName');
                    const warning = getWarning('highSchoolName');

                    return (
                        <form
                            onSubmit={submitForm}
                            id="editStudentProfileForm"
                            data-test="editStudentProfileForm"
                            data-testid="profile.student-info.edit-form"
                            onKeyDown={onKeyDown}
                        >
                            <div className={`container ${styles.editStudentProfileForm}`}>
                                <div className="row">

                                    <div className={`col-md-8`}>
                                        <h5
                                            className="mt48"
                                            data-testid="profile.student-info.edit-form.high-school-heading"
                                        >
                                            HIGH SCHOOL
                                        </h5>
                                        <div className={`container ${styles.container}`}>
                                            <div className={`${styles.row} pt0`}>
                                                <CheckBox
                                                    id="optInCollegeRecruitment"
                                                    field="collegeRecruiting"
                                                    customLabel="I agree to share my academic information with college coaches on UTR Sports."
                                                    formGroupCssClass={styles.checkBox}
                                                    data-testid="profile.student.opt-in-recruiting-checkbox"
                                                    {...getClickAttrs({
                                                        category: `Player Profile`,
                                                        context: `College Recruitment Opt ${values.collegeRecruiting}`,
                                                        location: 'Student Info Edit CTA',
                                                    })}
                                                />
                                            </div>
                                            <div className={`row ${styles.row}`}>
                                                <div className="col-md-4">
                                                    <div
                                                        className={styles.label}
                                                        data-testid="profile.student-info.edit-form.high-school-label"
                                                    >
                                                        High School
                                                    </div>
                                                </div>
                                                <div className={`col-md-8 form-group-xl mt8 mb8 ${(touched.highSchoolId && error) && 'is-invalid'}`}>
                                                    <SchoolSearch
                                                        className="form-control d-none d-md-block"
                                                        searchContainerClassName="mt0 mb0"
                                                        entityId={defaultValues.highSchoolId}
                                                        placeholder="Search school by name"
                                                        clearAfterSelect={false}
                                                        closeAfterSelect={true}
                                                        searchEndPoint="/highSchools"
                                                        schoolClubSearch={false}
                                                        displaySchoolNameAfterSelect={true}
                                                        showSearchClearIcon={true}
                                                        query={defaultValues.highSchoolName}
                                                        onChange={(query) => {
                                                            const { searchQuery } = this.state;

                                                            setValue('highSchoolName', query);

                                                            if (query !== searchQuery) {
                                                                setValue('highSchoolId', null);
                                                            }
                                                        }}
                                                        handleSchoolSelect={(value) => {
                                                            setValue('highSchoolId', value.id);
                                                            setValue('highSchoolName', value.name);
                                                            const locationString = value.location.googleFormattedName || value.location.display;
                                                            setValue('highSchoolLocation', locationString);
                                                        }}
                                                        handleClearSchoolClick={() => {
                                                            setValue('highSchoolId', null);
                                                            setValue('highSchoolLocation', null);
                                                        }}
                                                    />
                                                    <div className={`d-block d-md-none`}>
                                                        <Input
                                                            placeholder={`School Name`}
                                                            id={`schoolNameInput`}
                                                            field={`highSchoolName`}
                                                            data-testid="profile.student.school-name-input"
                                                            validate={createReactFormValidator(required)}
                                                            hiddenLabel={true}
                                                            type="text"
                                                        />
                                                    </div>
                                                    <Input
                                                        id={`schoolInput`}
                                                        field={`highSchoolId`}
                                                        hiddenLabel={true}
                                                        type="hidden"
                                                    />
                                                    <div className={`${(touched.highSchoolName && error) && 'error-indicator'}`} />
                                                    {(touched.highSchoolName) &&
                                                ((error && <div className="invalid-feedback">{error}</div>) ||
                                                    (warning && <div className="warning-feedback">{warning}</div>))}

                                                </div>
                                            </div>
                                            <div className={`row ${styles.row}`}>
                                                <div className="col-md-4">
                                                    <div
                                                        className={styles.label}
                                                        data-testid="profile.student-info.edit-form.location-label"
                                                    >
                                                        Location
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <Location
                                                        label="City"
                                                        placeholder={`City`}
                                                        id="highSchoolLocation"
                                                        field={`highSchoolLocation`}
                                                        data-testid="profile.student.location-input"
                                                        inputProps={{
                                                            className: `form-control`,
                                                        }}
                                                        hiddenLabel={true}
                                                    />
                                                </div>
                                            </div>

                                            <div className={`row ${styles.row}`}>
                                                <div className="col-md-4">
                                                    <div
                                                        className={styles.label}
                                                        data-testid="profile.student-info.edit-form.grad-month-year-label"
                                                    >
                                                        Graduating Month and Year
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <div className="row">
                                                        <div className="col-5">
                                                            <Select
                                                                id="graduationMonth"
                                                                field="graduationMonth"
                                                                options={monthOptions}
                                                                // validate={required}
                                                                emptyOption="Month"
                                                                hiddenLabel={true}
                                                                data-testid="profile.student.grad-month-select"
                                                            />
                                                        </div>
                                                        <div className="col-7">
                                                            <Select
                                                                id="graduationYear"
                                                                field="graduationYear"
                                                                options={gradYearOptions}
                                                                // validate={required}
                                                                isArray={true}
                                                                hiddenLabel={true}
                                                                emptyOption="Year"
                                                                data-testid="profile.student.grad-year-select"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={`row ${styles.row}`}>
                                                <div className="col-md-4">
                                                    <div
                                                        className={styles.label}
                                                        data-testid="profile.student-info.edit-form.gpa-label"
                                                    >
                                                        High School GPA
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <Input
                                                        type="number"
                                                        step="any"
                                                        id="highSchoolGpa"
                                                        data-test="highSchoolGpa"
                                                        field="highSchoolGpa"
                                                        placeholder="High School GPA"
                                                        data-testid="profile.student.gpa-input"
                                                        validate={createReactFormValidator([range(0, 5)])}
                                                    />
                                                </div>
                                            </div>
                                            <div className={`row ${styles.row}`}>
                                                <div className="col-md-4">
                                                    <div
                                                        className={styles.label}
                                                        data-testid="profile.student-info.edit-form.sat-label"
                                                    >
                                                        SAT Score
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <Input
                                                        id="sat"
                                                        field="sat"
                                                        type="number"
                                                        placeholder="SAT Score"
                                                        data-testid="profile.student.sat-input"
                                                        validate={createReactFormValidator([range(0, 1600), integer])}
                                                    />
                                                </div>
                                            </div>
                                            <div className={`row ${styles.row}`}>
                                                <div className="col-md-4">
                                                    <div
                                                        className={styles.label}
                                                        data-testid="profile.student-info.edit-form.act-label"
                                                    >
                                                        ACT Score
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <Input
                                                        id="act"
                                                        field="act"
                                                        type="number"
                                                        placeholder="ACT Score"
                                                        data-testid="profile.student.act-input"
                                                        validate={createReactFormValidator([range(1, 36), integer])}
                                                    />
                                                </div>
                                            </div>
                                            <div className={`row ${styles.row}`}>
                                                <div className="col-md-4">
                                                    <div
                                                        className={styles.label}
                                                        data-testid="profile.student-info.edit-form.toefl-label"
                                                    >
                                                        TOEFL Score
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <Input
                                                        id="toefl"
                                                        field="toefl"
                                                        type="number"
                                                        placeholder="TOEFL Score"
                                                        data-testid="profile.student.toefl-input"
                                                        validate={createReactFormValidator([range(0, 120), integer])}
                                                    />
                                                </div>
                                            </div>
                                            <div className={`row ${styles.row}`}>
                                                <div className="col-md-4">
                                                    <div
                                                        className={styles.label}
                                                        data-testid="profile.student-info.edit-form.coursework-label"
                                                    >
                                                        Current Coursework
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <Textarea
                                                        id="coursework"
                                                        field="coursework"
                                                        placeholder="Current Coursework"
                                                        rows="5"
                                                        data-testid="profile.student.coursework-textarea"
                                                    />
                                                </div>
                                            </div>
                                            <div className={`row ${styles.row}`}>
                                                <div className="col-md-4">
                                                    <div
                                                        className={styles.label}
                                                        data-testid="profile.student-info.edit-form.major-of-interest-label"
                                                    >
                                                        Major of Interest
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <Input
                                                        id="majorOfInterest"
                                                        field="majorOfInterest"
                                                        type="text"
                                                        placeholder="Major of Interest"
                                                        maxLength={100}
                                                        data-testid="profile.student.major-input"
                                                    />
                                                </div>
                                            </div>
                                            <div className={`row ${styles.row}`}>
                                                <div className="col-md-4">
                                                    <div
                                                        className={styles.label}
                                                        data-testid="profile.student-info.edit-form.transcript-label"
                                                    >
                                                        Transcript
                                                        <InfoButton hoverText={supportedPlayerStudentFileTypesForInfoButton} />
                                                    </div>
                                                </div>
                                                <div className="col-md-8 d-block d-md-flex aic">
                                                    <Input id="updateTranscript" field={'updateTranscript'} value={defaultValues.updateTranscript} type="hidden" />
                                                    {(!values.updateTranscript && defaultValues.transcriptFileName && defaultValues.transcriptLink) ? (
                                                        <React.Fragment>
                                                            <LinkAnchor link={defaultValues.transcriptLink} useAnchor={true} testId={'transcriptFileName'}>{defaultValues.transcriptFileName}</LinkAnchor>
                                                            <span
                                                                className="close-icon"
                                                                onClick={(e) => {
                                                                    setValue('updateTranscript', true);
                                                                    this.props.handleRemoveExistingTranscript(e);
                                                                }}
                                                            >
                                                                <Img className="close-icon" src="/img/icons/close-icon-lg.svg" data-test={`transcriptRemoveFile`} />
                                                            </span>
                                                        </React.Fragment>
                                                    ) : (
                                                        <React.Fragment>
                                                            <label
                                                                className={`${styles.uploadTranscriptBtn}`}
                                                                data-testid="profile.student-info.edit-form.upload-transcript-label"
                                                            >
                                                                <div data-testid="profile.student-info.edit-form.upload-transcript-text">
                                                                    Upload Transcript
                                                                </div>
                                                                <input
                                                                    accept={supportedPlayerStudentFileTypesAcceptsString}
                                                                    type="file"
                                                                    id={`transcriptInput`}
                                                                    data-test={'transcriptInput'}
                                                                    data-testid="profile.student-info.edit-form.transcript-input"
                                                                    onChange={(e) => {
                                                                        setValue('updateTranscript', true);
                                                                        this.props.handleUploadTranscriptFile(e);
                                                                    }}
                                                                />
                                                            </label>
                                                            {(this.props.currentUploadedTranscriptFileName) && (
                                                                <div
                                                                    className={`d-block d-md-flex aic jcc`}
                                                                    data-testid="profile.student-info.edit-form.transcript-current-name"
                                                                >
                                                                    {this.props.currentUploadedTranscriptFileName}
                                                                </div>
                                                            )}
                                                        </React.Fragment>
                                                    )}
                                                </div>
                                            </div>
                                            <div className={`row ${styles.row}`}>
                                                <div className="col-md-4">
                                                    <div
                                                        className={styles.label}
                                                        data-testid="profile.student-info.edit-form.tennis-resume-label"
                                                    >
                                                        Tennis Resume
                                                        <InfoButton hoverText={supportedPlayerStudentFileTypesForInfoButton} />
                                                    </div>
                                                </div>
                                                <div className="col-md-8 d-block d-md-flex aic">
                                                    <Input id="updateTennisResume" field={'updateTennisResume'} value={defaultValues.updateTennisResume} type="hidden" />
                                                    {(!values.updateTennisResume && defaultValues.tennisResumeFileName && defaultValues.tennisResumeLink) ? (
                                                        <React.Fragment>
                                                            <LinkAnchor link={defaultValues.tennisResumeLink} useAnchor={true} testId={'tennisResumeFileName'}>{defaultValues.tennisResumeFileName}</LinkAnchor>
                                                            <span
                                                                className="close-icon"
                                                                onClick={(e) => {
                                                                    setValue('updateTennisResume', true);
                                                                    this.props.handleRemoveExistingTennisResume(e);
                                                                }}
                                                            >
                                                                <Img className="close-icon" src="/img/icons/close-icon-lg.svg" data-test={`tennisResumeRemoveFile`} />
                                                            </span>
                                                        </React.Fragment>
                                                    ) : (
                                                        <React.Fragment>
                                                            <label
                                                                className={`${styles.uploadTennisResumeBtn}`}
                                                                data-testid="profile.student-info.edit-form.upload-tennis-resume-label"
                                                            >
                                                                <div data-testid="profile.student-info.edit-form.upload-tennis-resume-text">
                                                                    Upload Tennis Resume
                                                                </div>
                                                                <input
                                                                    accept={supportedPlayerStudentFileTypesAcceptsString}
                                                                    type="file"
                                                                    id={`tennisResumeInput`}
                                                                    data-test={'tennisResumeFileInput'}
                                                                    data-testid="profile.student-info.edit-form.tennis-resume-input"
                                                                    onChange={(e) => {
                                                                        setValue('updateTennisResume', true);
                                                                        this.props.handleUploadTennisResumeFile(e);
                                                                    }}
                                                                />
                                                            </label>
                                                            {(this.props.currentUploadedTennisResumeFileName) && (
                                                                <div
                                                                    className={`d-block d-md-flex aic jcc`}
                                                                    data-testid="profile.student-info.edit-form.tennis-resume-current-name"
                                                                >
                                                                    {this.props.currentUploadedTennisResumeFileName}
                                                                </div>
                                                            )}
                                                        </React.Fragment>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="buttons text-right d-none d-md-block">
                                                <div className="mt16">
                                                    <button
                                                        onClick={() => {
                                                            handleCancel();
                                                        }}
                                                        type="button"
                                                        className="btn btn-default btn-xl text-uppercase d-inline"
                                                        data-testid="profile.student-info.edit-form.cancel-btn"
                                                    >
                                                        Cancel
                                                    </button>
                                                    <TrackedClick
                                                        eventName="Profile Info Updated"
                                                        label="Submit"
                                                        traits={
                                                            {
                                                                pageLocation: 'StudentInfo Edit Tab',
                                                            }
}
                                                    >
                                                        <button
                                                            type="submit"
                                                            className="btn btn-primary btn-xl text-uppercase ml16 d-inline"
                                                            disabled={submitting}
                                                            data-test="submit"
                                                            {...getClickAttrs({
                                                                category: 'Player Profile',
                                                                context: `Save Updated Profile Info`,
                                                                location: 'StudentInfo Edit Tab',
                                                            })}
                                                        >
                                                            {submitting ? 'Saving...' : 'Save'}
                                                        </button>
                                                    </TrackedClick>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`col-md-4`}>
                                        <h5
                                            className="mt48"
                                            data-testid="profile.student-info.edit-form.primary-contact-heading"
                                        >
                                            PRIMARY CONTACT
                                        </h5>
                                        <div className={`container ${styles.container} mt24`}>
                                            <Input
                                                label="FIRST NAME"
                                                id="coachFirstName"
                                                field="coachFirstName"
                                                type="text"
                                                placeholder="First Name"
                                                data-testid="profile.student.coach-first-name-input"
                                            />
                                            <Input
                                                label="LAST NAME"
                                                id="coachLastName"
                                                field="coachLastName"
                                                type="text"
                                                placeholder="Last Name"
                                                data-testid="profile.student.coach-last-name-input"
                                            />
                                            <Select
                                                id="relationship"
                                                label="RELATIONSHIP"
                                                field="relationship"
                                                options={relationshipOptions}
                                                attributeToSave="label"
                                                data-testid="profile.student.relationship-select"
                                            />
                                            <Input
                                                label="EMAIL"
                                                id="coachEmail"
                                                field="coachEmail"
                                                type="email"
                                                placeholder="Email"
                                                disableProfanityCheck={true}
                                                data-testid="profile.student.coach-email-input"
                                            />
                                            <PhoneNumber
                                                label="PHONE NUMBER"
                                                id="coachPhone"
                                                field="coachPhone"
                                                placeholder="Phone Number"
                                                validate={createReactFormValidator([intlPhoneNumber])}
                                            />
                                        </div>
                                    </div>
                                    <div className={`col-12 d-block d-md-none`}>
                                        <div className="mt16">
                                            <button
                                                type="submit"
                                                className="btn btn-block btn-primary btn-xl text-uppercase d-inline"
                                                disabled={submitting}
                                                data-test="submit"
                                                {...getClickAttrs({
                                                    category: `Player Profile`,
                                                    context: `Edit Student Info Save button`,
                                                    location: 'Player Profile CTA',
                                                })}
                                            >
                                                {submitting ? 'Saving...' : 'Save'}
                                            </button>
                                            <button
                                                onClick={() => {
                                                    handleCancel();
                                                }}
                                                type="button"
                                                className="btn btn-block btn-default btn-xl text-uppercase d-inline"
                                                {...getClickAttrs({
                                                    category: `Player Profile`,
                                                    context: `Edit Student Info Cancel button`,
                                                    location: 'Player Profile CTA',
                                                })}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    );
                }}
            </Form>
        );
    }
}
export default StudentTabEditForm;
